/** biome-ignore-all lint/performance/noBarrelFile: intentional re-export for migration */

/**
 * StyleX styles for the web app.
 *
 * Re-exports design system primitives from @animus/primaris.
 * Import directly from @animus/primaris for new code.
 */

import * as stylex from "@stylexjs/stylex";

import { colors, space } from "@animus/primaris/tokens.stylex";

export const SIDEBAR_EXPANDED_WIDTH = 240;

export {
  // Component styles
  alert,
  badge,
  button,
  card,
  form,
  // Utility styles
  grid,
  layout,
  modal,
  page,
  sidebar,
  spacing,
  spinner,
  table,
  text,
} from "@animus/primaris";

/**
 * Web-specific layout styles.
 *
 * Web app uses a simple sidebar + main content grid layout.
 * No window chrome or drag region concerns.
 * Supports dynamic sidebar width via CSS variable.
 */
export const webLayout = stylex.create({
  container: {
    display: "grid",
    gridTemplateColumns: `var(--sidebar-width, ${SIDEBAR_EXPANDED_WIDTH}px) 1fr`,
    height: "100vh",
    transitionProperty: "grid-template-columns",
    transitionDuration: "var(--primaris-sidebar-duration, 200ms)",
    transitionTimingFunction: "cubic-bezier(0.32, 1.15, 0.64, 1.0)",
  },
  containerResizing: {
    transitionDuration: "0ms",
  },
  main: {
    position: "relative",
    padding: space["2xl"],
    overflow: "auto",
    backgroundColor: colors.backgroundSubtle,
  },
});
